export { HashRoute } from './hashRoute.component';
